export default class CategoryListHeaderService {
    public init(): void {
        this.initShowAllHeaderCategories();
    }

    private initShowAllHeaderCategories(): void {
        const showMoreCategoriesButton = document.querySelector<HTMLAnchorElement>(".js-show-more-categories");

        if (showMoreCategoriesButton === null) {
            return;
        }

        showMoreCategoriesButton.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();
            this.showMoreCategories(showMoreCategoriesButton);
        });
    }

    private showMoreCategories(showMoreCategoriesButton: HTMLAnchorElement): void {
        showMoreCategoriesButton.remove();

        for (const headerCategory of document.querySelectorAll<HTMLUListElement>(".js-header-category")) {
            headerCategory.classList.remove("hidden", "mobile-hidden");
        }
    }
}
